import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  scenarioLabel: {
    id: 'seo_recommendation_card_title',
  },
  wordsOrPhrases: {
    id: 'seo_recommendation_card_words_phrases',
  },
});
